import { string, object, number, collection } from '@gogame/schemas';

import {
  NAME,
  OWNER,
  BUSINESS_PARTNER,
  EXPENSE_TYPE,
  REVENUE_SHARE,
  EXPENSE_TYPE_REV_SHARE,
  ADDITIONAL_FEE,
  ADDITIONAL_FEE_PERIOD,
  ADDITIONAL_FEE_PERIOD_TO,
  ADDITIONAL_FEE_PERIOD_FROM,
  TAX_FEE_PERCENT,
  SPEND_SOURCE,
  MEDIA_SOURCE,
} from './constants';

export const additionalFeeSchema = object({
  [TAX_FEE_PERCENT]: number().required('Fee is required'),
  [ADDITIONAL_FEE_PERIOD]: object({
    [ADDITIONAL_FEE_PERIOD_FROM]: string().required('Start date is required'),
    [ADDITIONAL_FEE_PERIOD_TO]: string().required('End date is required'),
  }),
});

export const additionalFeePeriodsSchema = collection(additionalFeeSchema);

export const AffiliateFormValidationSchema = object({
  [NAME]: string()
    .matches(/^[^[\]{}()]*$/, "Affiliate name can't contain brackets: [] {} ()")
    .required('Name is required'),
  [OWNER]: string().required('Owner is required'),
  [BUSINESS_PARTNER]: string().required('Business partner is required'),
  [EXPENSE_TYPE]: string().required('Expense type is required'),
  [REVENUE_SHARE]: number().when(EXPENSE_TYPE, (expenseType, schema) => {
    if (Number(expenseType) === EXPENSE_TYPE_REV_SHARE) {
      return schema.required('Revenue Share is required');
    }
    return schema;
  }),
  [ADDITIONAL_FEE]: additionalFeePeriodsSchema,
  [MEDIA_SOURCE]: object({ id: number(), name: string() }),
  [SPEND_SOURCE]: number().required('Spend source is required'),
});
